import React, { Component } from 'react';
import qs from 'qs';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import Cookies from 'js-cookie';
import { Button } from 'react-bootstrap';

import { chatStore, rSocket } from '../../../store/FrontChatStore';
import { navigate } from '../../../helper/HistoryHelper';

import {
  COOKIE_KEY_BRAND_NM,
  COOKIE_KEY_CHANNEL_ID,
  COOKIE_KEY_USER_KEY,
} from '../../../const/AppConst';

import Character from '../../loading/assets/btb-character.jpg';
import Styles from './CloseView.module.scss';

@observer
class CloseView extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
    this.state = {
      brandName: Cookies.get(COOKIE_KEY_BRAND_NM) || '퀀텀AI',
    };
    let queryParam = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    let isRating = queryParam.isRating;
    rSocket.requestChatApi(`/app/setting`).then(({ data }) => {
      this.message =
        isRating === 'true'
          ? data?.chatRatingClosedMessage
          : data?.chatClosedMessage;
    });
  }

  @observable
  message = '챗봇 상담을 종료했습니다.';

  componentDidMount() {}

  render() {
    return (
      <div className={`d-flex flex-column flex-default overflow-hidden`}>
        <div className={Styles.Header}>
          <div className={Styles.NotUseButton}></div>

          <p className={Styles.Label}>{this.state.brandName} 상담봇</p>

          <div className={Styles.NotUseButton}></div>
        </div>
        <div className={Styles.Content}>
          <div className={Styles.Character}>
            <img
              src={Character}
              alt="BTB Character"
              style={{
                width: '200px',
                height: '200px',
                objectFit: 'cover',
                borderRadius: '50%',
                backgroundColor: 'transparent',
              }}
            />
          </div>
          <div>
            <div className={Styles.LabelWrap}>
              <div className={Styles.Title}>{this.message}</div>
              <ul className={Styles.Label}>
                <li>
                  <p>
                    일정시간 입력이 없는 경우, 개인 정보 보호를 위해 챗봇과
                    상담을 종료합니다.
                  </p>
                </li>
                <li>
                  <p>채팅 상담을 원하시면, 상담 재시작 버튼을 선택해 주세요.</p>
                </li>
              </ul>
            </div>

            <Button
              style={{
                width: '100%',
                fontWeight: 'bold',
                padding: '0.75rem 0',
                borderRadius: 0,
                backgroundColor: '#FFE926',
                border: '#FFE926',
                color: 'var(--bs-gray-900)',
              }}
              onClick={() => {
                chatStore.setChannel(undefined);
                navigate(
                  `/?user_id=${Cookies.get(COOKIE_KEY_USER_KEY)}&chnlId=${Cookies.get(COOKIE_KEY_CHANNEL_ID)}`,
                );
              }}
            >
              상담 재시작
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default CloseView;
